module.exports = __webpack_public_path__ + "img/aexpress.2f7bff60.svg";